import { ChangeDetectionStrategy, Component, inject, Signal } from '@angular/core';
import { SearchService } from 'app-shell-data';
import { RenderInAppQuickSearchResultsDirective } from 'app-shell-ui';
import { ProductFastSearchResults } from 'product-quick-search-data';
import { ProductQuickSearchResultsComponent } from 'product-quick-search-ui';

@Component({
  selector: 'ideal-product-quick-search-results-provider',
  standalone: true,
  imports: [ProductQuickSearchResultsComponent, RenderInAppQuickSearchResultsDirective],
  templateUrl: './product-quick-search-results-provider.component.html',
  styleUrl: './product-quick-search-results-provider.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductQuickSearchResultsProviderComponent {
  private readonly _searchService = inject(SearchService) as SearchService<ProductFastSearchResults>;
  protected readonly searchResults = this._searchService.searchResults;
  protected readonly searchResultsMore = this._searchService.searchResultsMore as Signal<any>;
  protected readonly searchQuery = this._searchService.searchQuery;
}
